import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Link,
    Typography,
    LinearProgress, Alert, AlertTitle, Snackbar, Box,
    Container, Grid, Button, Modal, FormControl, NativeSelect, Select, MenuItem,
    Tooltip, styled, tooltipClasses, Popover,
    Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions, IconButton
} from '@mui/material';
import { GridViewOutlined as GridViewOutlinedIcon, StayCurrentLandscape } from '@mui/icons-material/';
import theme from '../../theme';
import moment from "moment";
import Icons from "../Icons/icons.svg";
import { determineMeasureStates } from "../../components/Measure/measure-logic";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Slide, Zoom, Flip, Bounce } from 'react-toastify';
import { requestForToken, onMessageListener } from "../../notifications/firebase";
import { API_REGISTRY, APP_CACHE, TILES } from '../../app/config'
import { getDataSources, deepCopy, deleteLodgiqCookie, round } from '../../app/util';
import { setApiURLVars, updateAppState } from '../../actions/appstate';
import dataService from '../../services/data.service';
import { sendLog } from "../../app/log-interface";

import RequestSupport from '../RequestSupport/'

import { useDataSource } from '../../hooks/data-sources';
import { useProductVariant } from "../../hooks/use-product-variant"

import Lottie from 'react-lottie';
import TableLoadingLottie from "../../lotties/table-loading.json";
import msg from "../../components/Workspace/messages";
import { useVisbilityState } from "../../hooks/helper-hooks";
import { compressWorker } from '@linways/table-to-excel';
import { NEW_PROPERTY_SYSTEM_SETTINGS } from '../../app/config';
import qrCode from '../Icons/mobile-app-qr-code.png';
import { useLocation } from 'react-router-dom';
import { deleteAllCartItems } from '../Modal/SendRestrictionsProductModal';

const TableLottieLoader = () => {
    const [loading, setLoading] = useState(false);
    function randomMessage() {
        const messages = msg;
        const randomIndex = Math.floor(Math.random() * messages.length);
        const randomMessage = messages[randomIndex];
        return randomMessage;
    }
    const defaultOptionsTable = {
        loop: true,
        autoplay: true,
        animationData: TableLoadingLottie,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(true);
        }, 2000); // Adding delay in milliseconds 

        // Clear the timeout if the component is unmounted before the delay is completed
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <Box className="lottie-main-container" >
                <Box className="table-lottie-container" >
                    <Lottie
                        options={defaultOptionsTable}
                        height={40}
                        width={40}
                    />
                    <div>
                        {randomMessage()}
                    </div>
                </Box>
            </Box>
        );
    }
    return null;
};

function FBNotifications(props) {
    // debugger;
    const [msgCount, setMsgCount] = useState(1);
    useEffect(() => {
        let isSubscribed = true;

        onMessageListener().then(payload => {
            // requestForToken();
            // setShow(true);
            // debugger;
            console.log('onMessageListener:', payload);
            let { notification } = payload;
            if (notification && notification.title) {

                toast(<><strong>{notification.title} </strong><br /> {notification.body} </>, {
                    position: "bottom-right",
                    // autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Slide,
                    autoClose: 3000,
                    type: toast.TYPE.SUCCESS,
                });
                setMsgCount(msgCount + 1);
            }
            // setNotification({title: payload.notification.title, body: payload.notification.body})
            // console.log(payload);
        }).catch(err => console.log('onMessageListener: ', err));

        return () => (isSubscribed = false);
    }, [msgCount]);

    return (<></>)
}

function Copyright(props) {

    return (
        <Typography variant="body2" color="text.secondary" {...props}>
            {'Copyright © '}
            < Link color="inherit" href="https://app.lodgiq.com/" >
                LodgIQ
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

function DashboardLogo({ pathname }) {
    // let isNewTab = pathname == "/analytics-reports" || pathname == "/groupIQ"
    // console.log("pathname",pathname)
    // console.log("isNewTab",isNewTab)
    const [isNewTab, setIsNewTab] = useState(false);
    const [titleText, setTitleText] = useState("")

    useEffect(() => {
        if (pathname == "/analytics-reports") {
            setTitleText("Advanced Intelligence")
        }
        if (pathname == "/groupIQ") {
            setTitleText("GroupIQ")
        }
        if (pathname == "/Group-IQ") {
            setTitleText("Group Pricing")
        }
        if (pathname == "/lodgiq-user-guide") {
            setTitleText("LodgIQ User Guide")
        }

        const timeout = setTimeout(() => {
            setIsNewTab(pathname == "/analytics-reports" || pathname == "/groupIQ" || pathname == "/Group-IQ" || pathname == "/lodgiq-user-guide");
        }, 1000); // 1 seconds

        return () => clearTimeout(timeout);
    }, [pathname]);


    return (
        <Link href='/' target='_blank' sx={{ lineHeight: "14px" }
        }>
            <Box className="logo-container" >
                <svg className='logo-icon' viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <g clip-path="url(#clip0_3902_2314)" >
                        <mask id="mask0_3902_2314" maskUnits="userSpaceOnUse" x="0" y="0" width="27" height="27" >
                            <path d="M26.3294 0.501099H0V26.3544H26.3294V0.501099Z" fill="white" />
                        </mask>
                        < g mask="url(#mask0_3902_2314)" >
                            <path d="M25.1408 15.1575C25.1893 15.1575 25.2267 15.1967 25.2267 15.2424V25.1798C25.2267 25.2277 25.187 25.2647 25.1408 25.2647H15.0907C15.0422 25.2647 15.0048 25.2255 15.0048 25.1798V15.2424C15.0048 15.1945 15.0445 15.1575 15.0907 15.1575H25.1408ZM25.1408 14.0693H15.0907C14.4347 14.0693 13.9043 14.5938 13.9043 15.2424V25.1798C13.9043 25.8283 14.4347 26.3529 15.0907 26.3529H25.1408C25.7968 26.3529 26.3272 25.8283 26.3272 25.1798V15.2424C26.3272 14.5938 25.7968 14.0693 25.1408 14.0693Z" fill="white" />
                            <path d="M1.18638 25.2669C1.13796 25.2669 1.10054 25.2277 1.10054 25.182V14.0693C0.493043 14.0693 0 14.5568 0 15.1575V25.182C0 25.8305 0.530462 26.3551 1.18638 26.3551H11.3246C11.9321 26.3551 12.4251 25.8676 12.4251 25.2669H1.18638Z" fill="white" />
                            <path d="M25.1431 0.501465H15.0907C14.4355 0.501465 13.9043 1.02667 13.9043 1.67454V11.6141C13.9043 12.262 14.4355 12.7872 15.0907 12.7872H25.1431C25.7983 12.7872 26.3294 12.262 26.3294 11.6141V1.67454C26.3294 1.02667 25.7983 0.501465 25.1431 0.501465Z" fill="#01A4EF" />
                            <path d="M11.2365 1.58929C11.285 1.58929 11.3224 1.62847 11.3224 1.67417V11.6116C11.3224 11.6594 11.2828 11.6964 11.2365 11.6964H1.18638C1.13796 11.6964 1.10054 11.6573 1.10054 11.6116V1.67417C1.10054 1.62629 1.14016 1.58929 1.18638 1.58929H11.2365ZM11.2365 0.501099H1.18638C0.530462 0.501099 0 1.02561 0 1.67417V11.6116C0 12.2601 0.530462 12.7846 1.18638 12.7846H11.2365C11.8925 12.7846 12.4229 12.2601 12.4229 11.6116V1.67417C12.4229 1.02561 11.8925 0.501099 11.2365 0.501099Z" fill="white" />
                            <path d="M6.37228 19.7579L7.33419 20.709L11.0628 17.0222V20.0474H12.4231V14.6652H6.97979V16.0102H10.1604L6.37012 19.7579H6.37228Z" fill="#B0E80E" />
                        </g>
                    </g>
                    < defs >
                        <clipPath id="clip0_3902_2314" >
                            <rect width="26.5652" height="26" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                    </defs>
                </svg>

                < Box className={`logo-text-title ${isNewTab ? 'new-tab' : ''}`}>
                    <img
                        src={`assets/img/Lodgiq-Logo.svg`}
                        alt={`Dashboard`}
                        loading="lazy"
                        className='logo-text'
                    />
                    {isNewTab && <div className='title-text' > {titleText} </div>}
                </Box>
            </Box>
        </Link>
    );
}
function DashboardLogoSmall(props) {
    return (
        <Link href='' target='_blank' sx={{ lineHeight: "14px" }
        }>
            <img
                src={`assets/img/dashboard-logo-small.png`}
                alt={`Dashboard`}
                height="30"
                loading="lazy"
            />
        </Link>
    );
}

function CustomSVGIcon(props) {
    const { icon, width, height, path } = props;
    return (
        <span className={'icon icon-custom ' + props.className} >
            <img src={path} width={width} height={height} />
            {/* <svg className="icon-svg" fill="white" viewBox="0 0 410 450" width={width} height={height}>
    <use href={`${Icons}#${icon}`} height="100%" width="100%" />
  </svg> */}
        </span>
    );
}

function DashboardFooter(props) {
    const dataSource = useDataSource();
    const { productVariant } = useProductVariant()
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const { auth, app } = state;
    const { profile } = auth;
    const { property_details } = profile;
    const { app_state, ui_state } = app.current_state;
    const [openRequestSupport, setOpenRequestSupport] = useState(false);
    // const [dsInfo, setDsInfo] = useState(getDataSources(property_details, app_state.property_id));
    const [dsInfo, setDsInfo] = useState(dataSource);
    const color = theme.palette;
    const [confirmOptions, setConfirmOptions] = useState({
        title: 'Are you sure to switch data source to {pms}?',
        descriptions: <Alert severity="warning">
            <AlertTitle>Warning </AlertTitle>
            This may lead to reset data of other users of same property!
        </ Alert >,
        labelOk: "Change",
        labelCancel: "Cancel",
        open: false,
    });
    // debugger;

    const [currentURLPath, setCurrentURLPath] = useState("");
    useEffect(() => {
        setCurrentURLPath(window.location.pathname);
    }, []);

    useEffect(() => {
        // debugger;
        let isSubscribed = true;
        //if (!dsInfo.data_sources.length) {
        //dsInfo.data_sources.push(dsInfo.active_source);
        //}

        setDsInfo((state) => {
            let ds = getDataSources(property_details, app_state.property_id);
            return { ...state, ...ds };
        });

        return () => (isSubscribed = false);
    }, [app_state.property_id, app_state.active_data_src.id]);

    useEffect(() => {
        if (ui_state?.openSupport) {
            setOpenRequestSupport(true);
        }
    }, [ui_state.openSupport])

    function openRequestSupportModal() {
        setOpenRequestSupport(true);
    }
    function handleRequestSupportClose() {
        setOpenRequestSupport(false);
        dispatch(
            updateAppState("support_close", {
                ui_state: {
                    openSupport: false
                },
            }, "settings_click")
        );
    }
    function getIndexOfActiveSource() {
        let index;
        if (dsInfo && dsInfo.data_sources && dsInfo.data_sources.length) {
            dsInfo.data_sources.filter((item, i) => {
                if (item.id == dsInfo.active_source.id) index = i;
            });
            return index;
        } else {
            return 0;
        }
    }
    const handleDSChange = (selectedIndex) => {
        // debugger;
        let registery = API_REGISTRY['SwitchDataSource'];
        let currentDS = dsInfo.active_source.id;
        let toDSIndex = selectedIndex;
        let toDS = dsInfo.data_sources[toDSIndex];
        let newUrl = setApiURLVars(registery.uri, { pid: app_state.property_id, fromDS: currentDS, toDS: toDS.id });

        let notification = { title: 'Switching Data Source', body: 'Please Wait...' };
        // let dataSourceToast = toast(<><strong>{notification.title}</strong><br />{notification.body}</>, {
        //     position: "bottom-right",
        //     // autoClose: false,
        //     hideProgressBar: false,
        //     closeOnClick: false,
        //     pauseOnHover: false,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
        //     transition: Slide,
        //     autoClose: false,
        //     type: toast.TYPE.SUCCESS,
        // });
        // setMsgCount(msgCount + 1);
        dataService.getData({
            api: newUrl,
            request: { method: 'GET' }
        })
            .then((rs) => {
                // debugger;
                let system_settings = deepCopy(rs.system_settings);
                const { property_id } = app_state;

                setConfirmOptions((state) => {
                    return { ...state, showLoader: false, showSuccess: true };
                });
                profile.property_details[dsInfo.index].active_source = deepCopy(toDS);
                if (system_settings && !system_settings.inventory_settings) {
                    system_settings = { ...NEW_PROPERTY_SYSTEM_SETTINGS, ...system_settings };
                }
                profile.property_details[dsInfo.index].system_settings[0] = { ...system_settings };
                profile.property_details[dsInfo.index].permissions = rs.permissions;
                window.analyze.track("ds_changed", {
                    "previous_data_source": app_state.active_data_src,
                    "selected_data_source": dsInfo.active_source.id,
                    // ...event_metadata
                }, { ...app.current_state }, { app_state: { property: toDS }, ui_state: {} });
                sendLog({ category: "dashboard_click", action: "change_data_source" }, { ...app.current_state }, { app_state: { property: toDS }, ui_state: {} });

                // ui_state.active_tiles = [productVariant.default_tile];
                // APP_CACHE.active_tiles = [productVariant.default_tile];
                ui_state.table_filters.table_common.segments = [{
                    "code": "all",
                    "name": "all"
                }];

                let segmented_view = false;
                const allowedSegmentsTrue = [
                    'top_market_segment',
                    'market_segment',
                    'room_class',
                    'room_type',
                    'rate_plan',
                    'paxPerBooking',
                    'paxProfile',
                    'leadTime',
                    'channel',
                    'lengthOfStay'
                ];
                if (allowedSegmentsTrue.includes(app_state.workspace_controls.segmentType)) {
                    // if(['top_market_segment', 'market_segment', 'room_class', 'room_type', 'rate_plan', 'paxPerBooking', 'paxProfile', ''].includes(app_state.workspace_controls.segmentType)){
                    segmented_view = true;
                }

                dispatch({
                    type: "UPDATE_STATE", payload: {
                        app_state: {
                            workspace_controls: { ...app_state.workspace_controls, segmented_view: segmented_view },
                            data_load: false,
                            kpi_load: false,
                        },
                        ui_state: {
                            showSpinner: false,
                        }
                    }
                });

                dispatch((dispatch) => {
                    dispatch({ type: "SYSTEM_SETTINGS_UPDATED", payload: profile });
                });

                setTimeout(() => {
                    setConfirmOptions((state) => {
                        return { ...state, open: false, showLoader: false, showSuccess: false };
                    });
                    window.location.reload();
                }, 800);

                // notification.title = "Data Source Updated";
                // notification.body = "New Data Source is " + toDS.name + " (" + toDS.id + "), Reloading Screen...";
                // toast.update(dataSourceToast, {
                //     render: <><strong>{notification.title}</strong><br />{notification.body}</>,
                //     type: toast.TYPE.SUCCESS,
                //     autoClose: 3000
                // })
            }, (err) => {
                console.error("Data Source change Error!", err);
            })
    };
    async function handleUserAction(action) {

        if (!action) {
            setConfirmOptions((state) => {
                return { ...state, open: false };
            })
            // handleDSChange(conFirmDialog.event, conFirmDialog.option);
        }
        if (action === 'agree') {
            // debugger;
            let property_info = {};
            const prop_details = property_details.filter((item) => {
                if (Number(item.id) === profile.default_property_id) {
                    property_info = { ...item };
                }
            });
            const measuresState = determineMeasureStates({
                active_tiles: property_info.product_variant.default_tile,
                userSelected_left_measure: TILES[property_info.product_variant.default_tile].chartConfig.defaultMeasures[0],
                userSelected_right_measure: TILES[property_info.product_variant.default_tile].chartConfig.defaultMeasures[1],
            });
            // app_state.workspace_controls.sdlyOn = false;
            // app_state.workspace_controls.sdYear = moment(app_state.as_of_date).subtract(1, 'years').format('YYYY');
            // app_state.workspace_controls.pickUpDays = 1;
            // app_state.workspace_controls.pickUpType = "Standard";
            // ui_state.active_tiles = [property_info.product_variant.default_tile];
            ui_state.left_measure = measuresState.selectedLeftMeasure.value ? measuresState.selectedLeftMeasure.value : null;
            ui_state.right_measure = measuresState.selectedRightMeasure.value ? measuresState.selectedRightMeasure.value : null;
            ui_state.right_measures_list = measuresState.rightList;
            ui_state.left_measures_list = measuresState.leftList;
            setConfirmOptions((state) => {
                return { ...state, showLoader: true };
            });

            await deleteAllCartItems({ dispatch, app_state })
            handleDSChange(confirmOptions.selectedIndex);
            // handleDSChange(conFirmDialog.event, conFirmDialog.option);
        }
        if (action === 'disagree') {
            setConfirmOptions((state) => {
                return { ...state, open: false };
            })
            // handleDSChange(conFirmDialog.event, conFirmDialog.option);
        }
    }
    function openConfirmDialog(event, item, selectedIndex) {
        let isSelected = Number(item.id) === Number(dsInfo.active_source.id) ? true : false;
        if (!isSelected) {
            setConfirmOptions((state) => {
                dispatch(updateAppState('dataSrcChanged', {
                    app_state: {
                        ...app_state,
                        active_data_src: { ...app_state.active_data_src, ...item },
                        roomTypeRestrictions: [],
                        savedRestrictions: [],
                        alertShowable: true
                    },
                    ui_state: { ...ui_state }
                }));
                return { ...state, pms: item.pms, open: true, selectedIndex: selectedIndex, event: event, item: item };
            })
        }
    }

    let dataSourcesOptions = () => {
        if (dsInfo.data_sources) {
            return dsInfo.data_sources.map((item, i) => {
                return <MenuItem value={i} onClick={(event) => openConfirmDialog(event, item, i)}> {item.pms} </MenuItem>
            });
        }
    }
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    let subModules = ['analytics-reports', 'groupIQ', '/feeder-market-reports', 'Group-IQ', 'lodgiq-user-guide'];
    const { pathname } = useLocation();
    const shouldHideFooterSection = subModules.some(sub => pathname.includes(sub));
    let isModuleDisabled = (currentURLPath === '/settings') ? "disabled" : "";

    return (
        <Box sx={{ position: 'fixed', bottom: 0, zIndex: 999, background: color.grey.Gray2, color: color.white.main, width: '100%' }}>
            <Container maxWidth="xxl" className={`container-control ${currentURLPath !== '/' ? 'footer' : ''}`}>
                {currentURLPath === "/settings" &&
                    <Box className="corner-icon bottom-corner" >
                        <svg width="12" height="12" fill='#606060' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" > <path d="M8,8 H0 V0 c0,4.42,3.59,8,8,8 Z" /> </svg>
                    </Box>
                }
                <Grid container justifyContent="space-between" spacing={0.2} sx={{ lineHeight: "normal", height: "100%", alignItems: "center", mt: 0, mb: 0 }}>
                    <Grid item sm={6} >
                        <div className={shouldHideFooterSection ? 'dn' : ''}>
                            {
                                dsInfo.data_sources &&
                                <Select
                                    defaultValue={getIndexOfActiveSource()}
                                    value={getIndexOfActiveSource()}
                                    // onChange={handleDSChange}
                                    size="small"
                                    width="100"
                                    id={`${ui_state.active_tiles.join("-")}__footer-ds-selector`}
                                    disabled={isModuleDisabled}
                                    className={`footer-ds-selector ${isModuleDisabled ? 'footer-ds-disabled' : ''}`}
                                    renderValue={(value) => {
                                        return (<>
                                            <LightTooltip title="DATA SOURCE" arrow followCursor >
                                                <span><DataSourceIcon /></span >
                                            </LightTooltip>
                                            {dsInfo.data_sources[getIndexOfActiveSource()].pms} </>)
                                    }}
                                >
                                    {dataSourcesOptions()}
                                </Select>
                            }

                            {
                                app_state.latest_data_asof && productVariant.tiles && productVariant.tiles.includes('otb') && <span id={`${ui_state.active_tiles.join("-")}__footer-asof-ts`} className='footer-asof-ts' >
                                    <LightTooltip title="AS OF DATE" arrow followCursor >
                                        <span><AsOfIcon /></span >
                                    </LightTooltip>
                                    < span className='footerText' style={{ color: color.white.main2, marginLeft: 25 }
                                    }>
                                        {/* {moment(app_state.data_as_of).format('MMMM DD, YYYY')} -  */}
                                        {/* {moment.parseZone(app_state.latest_data_asof).format('MMMM DD, YYYY')} */}
                                        {app_state.latest_data_asof ? moment.parseZone(app_state.latest_data_asof).format('MMMM DD, YYYY') : ''}

                                        {/* {app_state.metas.osr.latest_data_asof} */}
                                    </span>
                                </span>}
                        </div>
                    </Grid>

                    < Grid item sm={6} sx={{ display: "flex", alignItems: "center", justifyContent: "end", gap: "8px" }}>

                        {/* Show QR Code to download Mobile App */}
                        < LightTooltip title="DOWNLOAD MOBILE APP" arrow >
                            <Button
                                id={`${ui_state.active_tiles.join("-")}__footer-download-mobile-app`}
                                className="circle-border-icon"
                                sx={{ background: Boolean(anchorEl) ? "#333333" : "transparent" }}
                                onClick={handleOpen}
                            >
                                <svg width="10" height="14" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                    <g clip-path="url(#clip0_3118_3712)" >
                                        <path d="M10.1899 0.5H2.18994C1.08327 0.5 0.189941 1.40929 0.189941 2.53571V17.4643C0.189941 18.5907 1.08327 19.5 2.18994 19.5H10.1899C11.2966 19.5 12.1899 18.5907 12.1899 17.4643V2.53571C12.1899 1.40929 11.2966 0.5 10.1899 0.5ZM1.52327 4.57143H10.8566V15.4286H1.52327V4.57143ZM2.18994 1.85714H10.1899C10.5633 1.85714 10.8566 2.15571 10.8566 2.53571V3.21429H1.52327V2.53571C1.52327 2.15571 1.81661 1.85714 2.18994 1.85714ZM10.1899 18.1429H2.18994C1.81661 18.1429 1.52327 17.8443 1.52327 17.4643V16.7857H10.8566V17.4643C10.8566 17.8443 10.5633 18.1429 10.1899 18.1429Z" fill="white" />
                                        <path d="M5.87012 12.9314C6.04346 13.1079 6.33679 13.1079 6.52346 12.9314L8.81679 10.5972C8.99012 10.4207 8.99012 10.1222 8.81679 9.93216C8.64346 9.75574 8.35012 9.75574 8.16346 9.93216L6.65679 11.4793V7.42145C6.65679 7.16359 6.45679 6.96002 6.20346 6.96002C5.95012 6.96002 5.75012 7.16359 5.75012 7.42145V11.4793L4.24346 9.93216C4.07012 9.75574 3.77679 9.75574 3.59012 9.93216C3.40346 10.1086 3.41679 10.4072 3.59012 10.5972L5.88346 12.9314H5.87012Z" fill="white" />
                                    </g>
                                    < defs >
                                        <clipPath id="clip0_3118_3712" >
                                            <rect width="12" height="19" fill="white" transform="translate(0.189941 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </Button>
                        </LightTooltip>
                        < Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "center",
                            }}
                            transformOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                            }}
                            sx={{
                                marginTop: "-8px", // Push the modal 10px higher
                                "& .MuiPaper-root": {
                                    borderRadius: "16px",
                                    backgroundColor: "transparent",
                                    boxShadow: "rgba(0, 0, 0, 0.2) 0px 30px 40px,  rgba(0, 0, 0, 0.1) 0px -12px 20px,  rgba(0, 0, 0, 0.1) 0px 4px 6px,  rgba(0, 0, 0, 0.15) 0px 8px 10px,  rgba(0, 0, 0, 0.08) 0px -3px 5px"
                                },
                            }}
                        >
                            <Box className="mobile-app-qr-code" >
                                <img height="200" width="200" src={qrCode} alt="QR Code" />
                            </Box>

                        </Popover>

                        < div style={{ width: "2px", height: "14px", borderRight: "1px solid #B2B2B2" }}> </div>

                        {/* Open Request Support Popup */}
                        <LightTooltip title="REQUEST SUPPORT" arrow >
                            <Button
                                id={`${ui_state.active_tiles.join("-")}__footer-request-support`}
                                className='circle-border-icon'
                                sx={{ background: openRequestSupport ? "#333333" : "transparent" }}
                                onClick={openRequestSupportModal}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#90d6f0" viewBox="0 0 256 256" > <path d="M144.27,45.93a8,8,0,0,1,9.8-5.66,86.22,86.22,0,0,1,61.66,61.66,8,8,0,0,1-5.66,9.8A8.23,8.23,0,0,1,208,112a8,8,0,0,1-7.73-5.94,70.35,70.35,0,0,0-50.33-50.33A8,8,0,0,1,144.27,45.93Zm-2.33,41.8c13.79,3.68,22.65,12.54,26.33,26.33A8,8,0,0,0,176,120a8.23,8.23,0,0,0,2.07-.27,8,8,0,0,0,5.66-9.8c-5.12-19.16-18.5-32.54-37.66-37.66a8,8,0,1,0-4.13,15.46Zm81.94,95.35A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.26,56.26,0,0,1,72.92,32.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a8.44,8.44,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z" > </path></svg >
                            </Button>
                        </LightTooltip>
                        < Modal
                            open={openRequestSupport}
                            onClose={handleRequestSupportClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description">

                            <RequestSupport handleClose={handleRequestSupportClose} />

                        </Modal>


                        < Box className='footerText' sx={{ float: 'right', pt: 0.3 }}>
                            <span style={{ color: color.grey.Gray3 }} align="right" {...props}>
                                {'© '} {moment().format('YYYY')} <span onClick={() => { deleteLodgiqCookie("loginCount") }}> LodgIQ.</span> All rights reserved.
                            </span>
                        </Box>

                    </Grid>
                </Grid>
            </Container>

            < ToastContainer />
            <ConfirmDialog {...confirmOptions} handleUserAction={handleUserAction} />
        </Box>

    );
}

function ResponsiveTilesMenu(props) {
    const { onClick } = props;
    const color = theme.palette;
    return (
        <Button onClick={onClick} sx={{ minWidth: 'auto' }
        }>
            <GridViewOutlinedIcon fontSize='large' color='white' />
        </Button>
    );
}

function AsOfIcon() {
    return (
        <span style={{ position: 'relative' }
        }>
            <svg xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" style={{ width: 18, marginRight: 5, position: 'absolute', top: -2 }} viewBox="0 0 256 256" > <path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z" > </path></svg >
        </span>
    );
}
function DataSourceIcon() {
    return (
        <svg id="Layer_1" fill='#fff' style={{ width: 14, marginRight: 5 }
        } data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 116.67" > <title></title><path className="cls-1" d="M16.94,25.56c7.76,2.6,18.58,4.2,30.59,4.2s22.82-1.6,30.58-4.2c6.82-2.28,11-5,11-7.72s-4.22-5.45-11-7.73c-7.76-2.58-18.57-4.2-30.57-4.2s-22.83,1.62-30.6,4.2c-14.45,4.83-14.85,10.49,0,15.45ZM85.37,85.72h11.3V81.44a1.78,1.78,0,0,1,.71-1.52c1.2-.8,2.38.3,3.21,1,2.36,2.13,6.62,7,7.86,8a1.74,1.74,0,0,1,0,2.74c-1.27,1.1-5.79,6.22-8.08,8.26-.8.7-1.88,1.58-3,.84a1.78,1.78,0,0,1-.71-1.52V95.06H85.37V85.72ZM106,50.33a1.49,1.49,0,0,0-1-.37.86.86,0,0,0-.22,0H72.89a3.12,3.12,0,0,0-2.22.93,3.09,3.09,0,0,0-.93,2.22v60.38a3.18,3.18,0,0,0,3.15,3.16h46.79a3.18,3.18,0,0,0,3.15-3.16V68.34a1.34,1.34,0,0,0,0-.35,1.51,1.51,0,0,0-.48-1.07L106.12,50.43a.53.53,0,0,0-.12-.1Zm-4.43,4.36V65.46a5.08,5.08,0,0,0,1.25,3.36c.77.77,3.58,2.57,4.75,2.57h10.64v40.25c0,.07-.11.17-.18.22s0,.1-.15.1H74.75a.26.26,0,0,1-.23-.1.37.37,0,0,1-.1-.22V55a.25.25,0,0,1,.1-.22.33.33,0,0,1,.23-.1Zm4.88,10.45V55.39l10.47,11.2h-9a1.46,1.46,0,0,1-1.45-1.45ZM6,47c.53,2.52,4.63,5,11,7.16,7.76,2.6,18.58,4.2,30.59,4.2,4.18,0,8.23-.2,12.05-.56v6c-3.84.35-7.88.54-12,.54-12.62,0-24.09-1.72-32.45-4.52A37,37,0,0,1,6,55.5V73.22c.53,2.52,4.63,5,11,7.17,7.76,2.58,18.58,4.19,30.59,4.19,4.17,0,8.22-.19,12-.55V90c-3.85.35-7.89.54-12.05.54-12.61,0-24.09-1.73-32.45-4.53A37.33,37.33,0,0,1,6,81.67V99.4c.53,2.51,4.63,5,11,7.16,7.77,2.59,18.58,4.2,30.59,4.2,4.19,0,8.23-.2,12-.57v4.6a8.41,8.41,0,0,0,.07,1.33c-3.87.36-7.93.55-12.11.55-12.61,0-24.09-1.73-32.45-4.53C10.68,110.67,0,105.83,0,100.05V98.16C0,71.77,0,44.23,0,17.88,0,12.31,5.76,7.63,15.06,4.52,23.44,1.72,34.93,0,47.54,0S71.61,1.72,80,4.53s14,7,14.94,11.85a2.91,2.91,0,0,1,.17,1V39.78H89.17v-13A36.86,36.86,0,0,1,80,31.14C71.63,34,60.16,35.67,47.55,35.67S23.45,34,15.06,31.14A36.93,36.93,0,0,1,6,26.86V47Z" /> </svg>
    );
}

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
    },
}));

function ConfirmDialog(props) {
    const { title, descriptions, labelOk, labelCancel, open, showLoader, showSuccess, handleUserAction, pms } = props;
    let newTitle = title;
    newTitle = newTitle.replace('{pms}', pms);
    return (
        <Dialog
            open={open}
            // onClose={() => handleUserAction()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            {showLoader && <>
                <LinearProgress color="green" />
                <Alert severity='info' >
                    Please wait...<br />
                    We are switching data source to {pms}
                </Alert>
            </>
            }
            {
                showSuccess && <>
                    <LinearProgress color="green" />
                    <Alert severity='success' >
                        Data source is switched to {pms} <br />
                        We are reloading data...
                    </Alert>
                </>
            }
            {
                !showLoader && !showSuccess && <>
                    <DialogTitle id="alert-dialog-title" >
                        {!title && "Are you sure about this action?"
                        }
                        {title && newTitle}
                    </DialogTitle>
                    < DialogContent >
                        <DialogContentText id="alert-dialog-description" >
                            {!descriptions && "Do this only if you prety sure about impacts of this action."}
                            {descriptions && descriptions}
                        </DialogContentText>
                    </DialogContent>
                    < DialogActions sx={{ pr: 3 }}>
                        <Button variant='outlined' color='info' onClick={() => handleUserAction('disagree')}>
                            {labelCancel && labelCancel}
                            {!labelCancel && "Cancel"}
                        </Button>
                        < Button variant='outlined' color='warning' onClick={() => handleUserAction('agree')} autoFocus >
                            {labelOk && labelOk}
                            {!labelOk && "Agree"}
                        </Button>
                    </DialogActions>
                </>
            }
        </Dialog>
    )
}

//This is for confirmation of user logout in case of inactivity for long time
function ConfirmLogoutDialog(props) {
    let { title, descriptions, labelOk, labelCancel, open, showLoader, showSuccess, handleUserAction, pms, graceTime = 1, timeout = 2, openConfirmDialog } = props;
    let newTitle = title;
    const visibility = useVisbilityState(document.visibilityState);
    let [graceTimeCounter, setGraceTimeCounter] = useState(graceTime * 60 * 1000);
    let [graceTimeDisplay, setGraceTimeDisplay] = useState(graceTime.toFixed(2));
    const compRefs = useRef({
        graceTimeCounter: graceTimeCounter, logoutTimer: null,
        hiddenTime: 0, visibleTime: 0, ts: 0,
        autologoutWorker: null, //new Worker('/workers/app.autologout.js')
        startCounterCalled: 0,
        documentHidden: false,
        open: open
    });

    // let autologoutWorker = new Worker('/workers/app.autologout.js');
    const onWorkerMessage = (event) => {
        const { status, ts } = JSON.parse(event.data);
        if (status === 'complete' && ts === compRefs.current.ts && compRefs.current.documentHidden) {
            handleUserAction('logout');
            // autologoutWorker.terminate();
        }
    };

    const startCounter = () => {
        clearInterval(compRefs.current.intervalId);
        // clearTimeout(compRefs.current.logoutTimer);
        // compRefs.current.autologoutWorker.terminate();
        const documentHidden = compRefs.current.documentHidden;
        let timeLapsed = 0;
        let { visibleTime, hiddenTime, startCounterCalled, open, graceTimeCounter } = compRefs.current;
        if (open) {
            compRefs.current.startCounterCalled = 1;
            startCounterCalled = 1;
        }
        if (documentHidden) {
            // debugger;
            compRefs.current.autologoutWorker.removeEventListener('message', onWorkerMessage);
            // compRefs.current.hiddenTime = moment().format('x');
            compRefs.current.ts = moment().format('x');
            if (open) {
                compRefs.current.autologoutWorker.postMessage({ type: 'autologout', ts: compRefs.current.ts, timeout: graceTimeCounter });
            } else {
                compRefs.current.autologoutWorker.postMessage({ type: 'autologout', ts: compRefs.current.ts, timeout: timeout + graceTimeCounter });
            }
            compRefs.current.autologoutWorker.addEventListener('message', onWorkerMessage);

            // let time = String((graceTimeCounter / 60000).toFixed(2)).split('.');
            // let min = time[0].toString().padStart(2, "0");
            // let sec = Math.round((time[1] * 60) / 100).toString().padStart(2, "0");
            // graceTimeDisplay = min + ':' + sec;
            // setGraceTimeDisplay(graceTimeDisplay);
            // compRefs.current.logoutTimer = 
            // setTimeout(() => {
            //     debugger;
            //     handleUserAction('logout');
            // }, graceTimeCounter);
        }

        if (!documentHidden) {
            compRefs.current.ts = moment().format('x');
            if (open && startCounterCalled && visibleTime && hiddenTime && visibleTime > hiddenTime) {
                timeLapsed = visibleTime - hiddenTime;
            }

            //debugger;
            if (open && timeLapsed >= compRefs.current.graceTimeCounter) {
                handleUserAction('logout');
            }
            if (!open && timeLapsed >= (compRefs.current.graceTimeCounter + timeout)) {
                handleUserAction('logout');
            }
            if (open && timeLapsed < compRefs.current.graceTimeCounter) {
                console.log("open: " + open, "timeLapsed: " + timeLapsed, "startCounterCalled: " + startCounterCalled, "graceTimeCounter: " + compRefs.current.graceTimeCounter, "visibleTime: " + visibleTime, "hiddenTime: " + compRefs.current.hiddenTime);

                //let timeLapsed = compRefs.current.visibleTime - compRefs.current.hiddenTime;
                console.log("graceTimeCounter: " + graceTimeCounter, timeLapsed);
                graceTimeCounter = compRefs.current.graceTimeCounter - timeLapsed;
                compRefs.current.graceTimeCounter = graceTimeCounter;
                setGraceTimeCounter(graceTimeCounter);
                let time = String((graceTimeCounter / 60000).toFixed(2)).split('.');
                let min = time[0].toString().padStart(2, "0");
                let sec = Math.round((time[1] * 60) / 100).toString().padStart(2, "0");
                graceTimeDisplay = min + ':' + sec;
                setGraceTimeDisplay(graceTimeDisplay);

                compRefs.current.intervalId = setInterval(() => {
                    // debugger;
                    graceTimeCounter = graceTimeCounter - 1000;
                    compRefs.current.graceTimeCounter = graceTimeCounter;
                    // if (graceTimeCounter <= 0) {
                    //     clearInterval(compRefs.current.intervalId);
                    // }
                    if (graceTimeCounter > -1) {
                        setGraceTimeCounter(graceTimeCounter);
                        let time = String((graceTimeCounter / 60000).toFixed(2)).split('.');
                        let min = time[0].toString().padStart(2, "0");
                        let sec = Math.round((time[1] * 60) / 100).toString().padStart(2, "0");
                        graceTimeDisplay = min + ':' + sec;
                        setGraceTimeDisplay(graceTimeDisplay);
                    }
                    if (graceTimeCounter <= 0) {
                        // debugger;
                        //Do logout action
                        clearInterval(compRefs.current.intervalId);
                        handleUserAction('logout');
                    }

                }, 1000);
                // compRefs.current.startCounterCalled += 1;
            }
            // autologoutWorker.postMessage({ type: 'autologout', timeout: graceTimeCounter });

        }

    }
    const omMouseEnter = () => {
        if (!document.hasFocus()) {
            window.focus();
        }
    }
    const OnFocus = () => {
        // debugger;
        if (!document.hasFocus()) {
            window.focus();
        }
        compRefs.current.documentHidden = false;
        compRefs.current.visibleTime = Number(moment().format('x'));
        compRefs.current.hiddenTime = Number(sessionStorage.getItem('documentHiddenTime'));
        sessionStorage.removeItem('documentHiddenTime');
        if (!compRefs.current.open) {
            graceTimeCounter = graceTime * 60000;
            setGraceTimeCounter(graceTimeCounter);
            compRefs.current.graceTimeCounter = graceTimeCounter;
            compRefs.current.startCounterCalled = 0;
        }
        if (compRefs.current.open) {
            compRefs.current.startCounterCalled = 1;
        }

        startCounter();

        console.log('document focused', timeout, graceTimeCounter, true);
    };
    const Onblur = () => {
        console.log('document blured');
        compRefs.current.documentHidden = true;
        clearInterval(compRefs.current.intervalId);
        console.log('graceTimeCounter', graceTimeCounter);

        if (compRefs.current.open) {
            compRefs.current.hiddenTime = Number(moment().format('x'));
            sessionStorage.setItem('documentHiddenTime', compRefs.current.hiddenTime);
            // compRefs.current.startCounterCalled = 1;
            // startCounter();
        }
        if (!compRefs.current.open) {
            // compRefs.current.hiddenTime = Number(moment().format('x'));
            // sessionStorage.setItem('documentHiddenTime', compRefs.current.hiddenTime);
        }
        startCounter();
    };

    const onVisibilityChange = (e) => {

        if (document.hidden) {
            // console.log('document is hidden');
            // compRefs.current.documentHidden = true;
            Onblur();
            // compRefs.current.startCounterCalled = 0;
            // compRefs.current.hiddenTime = Number(moment().format('x'));
            // sessionStorage.setItem('documentHiddenTime', Number(compRefs.current.hiddenTime));
        }
        if (!document.hidden) {
            window.focus();
            console.log('document is visible');
            // compRefs.current.documentHidden = false;
            OnFocus();
            // compRefs.current.visibleTime = Number(moment().format('x'));
            // compRefs.current.hiddenTime = Number(sessionStorage.getItem('documentHiddenTime'));
            // if (compRefs.current.hiddenTime && compRefs.current.visibleTime) {
            //     let timeLapsed = compRefs.current.visibleTime - compRefs.current.hiddenTime;
            //     if ((open && timeLapsed>= graceTimeCounter) || (!open && timeLapsed>= (graceTimeCounter + timeout))) {
            //         handleUserAction('logout');
            //     } else if(open && timeLapsed <graceTimeCounter){
            //         startCounter();
            //     } else if (!open && timeLapsed> timeout && timeLapsed <(graceTimeCounter + timeout)) {
            //         openConfirmDialog();
            //         startCounter();
            //     }
            // }
        }
    }

    const handleCrossTabActivity = (event) => {
        if (event.key === 'userActive' && compRefs.current.documentHidden) {
            const data = JSON.parse(event.newValue || '{}');
            if (data.status === 'true') {
                // User is active in another tab — reset the autologout worker timer
                startCounter();
            }
        }
    };

    useEffect(() => {
        sessionStorage.removeItem('documentHiddenTime');
        document.addEventListener("visibilitychange", onVisibilityChange);
        document.addEventListener('focus', OnFocus);
        document.addEventListener('blur', Onblur);
        document.addEventListener("mouseenter", omMouseEnter);
        window.addEventListener('storage', handleCrossTabActivity);
        // document.addEventListener("mouseleave", Onblur);

        if (!compRefs.current.autologoutWorker) {
            compRefs.current.autologoutWorker = new Worker('/workers/app.autologout.js');
        }
        startCounter();
        return () => {
            sessionStorage.removeItem('documentHiddenTime');
            document.removeEventListener('focus', OnFocus);
            document.removeEventListener('blur', Onblur);
            document.removeEventListener("visibilitychange", onVisibilityChange);
            compRefs.current.autologoutWorker.removeEventListener('message', onWorkerMessage);
            document.removeEventListener("mouseenter", omMouseEnter);
            // document.removeEventListener("mouseleave", Onblur);
            compRefs.current.autologoutWorker.terminate();
            window.removeEventListener('storage', handleCrossTabActivity);
        }
    }, []);


    useEffect(() => {
        // autologoutWorker.terminate();
        const { documentHidden } = compRefs.current;
        console.log('document visibility', visibility, documentHidden);
        compRefs.current.open = open;
        if (open) {
            sessionStorage.setItem('documentHiddenTime', moment().format('x'));
            // compRefs.current.startCounterCalled = 1;
        }
        if (open && !documentHidden) {
            // debugger;
            startCounter();
        }
        if (open && documentHidden) {
            setGraceTimeCounter(graceTime * 60 * 1000);
            let time = String((graceTimeCounter / 60000).toFixed(2)).split('.');
            let min = time[0].toString().padStart(2, "0");
            let sec = Math.round((time[1] * 60) / 100).toString().padStart(2, "0");
            graceTimeDisplay = min + ':' + sec;
            setGraceTimeDisplay(graceTimeDisplay);
        }
        if (!open) {
            clearInterval(compRefs.current.intervalId);
            compRefs.current.graceTimeCounter = graceTime * 60 * 1000;

            // autologoutWorker.terminate();
            // compRefs.current.ts = moment().format('x');

            // compRefs.current.autologoutWorker.postMessage({ type: 'autologout', ts: compRefs.current.ts, timeout: timeout + graceTimeCounter });
            // startCounter();
        }

        return () => {
            clearInterval(compRefs.current.intervalId);
        }

    }, [open]);

    return (
        <Dialog
            open={open}
            //onClose={() => handleUserAction()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ className: "confirm-dialog-paper" }
            }>


            <DialogContent className="confirm-dialog-content" >
                {/* Warning Icon */}
                < svg className="confirm-dialog-icon" width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M12.3125 28.0625C12.3125 28.3774 12.1874 28.6795 11.9647 28.9022C11.742 29.1249 11.4399 29.25 11.125 29.25H1.625C1.31006 29.25 1.00801 29.1249 0.785311 28.9022C0.562611 28.6795 0.4375 28.3774 0.4375 28.0625V1.9375C0.4375 1.62256 0.562611 1.32051 0.785311 1.09781C1.00801 0.875111 1.31006 0.75 1.625 0.75H11.125C11.4399 0.75 11.742 0.875111 11.9647 1.09781C12.1874 1.32051 12.3125 1.62256 12.3125 1.9375C12.3125 2.25244 12.1874 2.55449 11.9647 2.77719C11.742 2.99989 11.4399 3.125 11.125 3.125H2.8125V26.875H11.125C11.4399 26.875 11.742 27.0001 11.9647 27.2228C12.1874 27.4455 12.3125 27.7476 12.3125 28.0625ZM28.5902 14.1598L22.6527 8.22234C22.4298 7.99952 22.1276 7.87434 21.8125 7.87434C21.4974 7.87434 21.1952 7.99952 20.9723 8.22234C20.7495 8.44517 20.6243 8.74738 20.6243 9.0625C20.6243 9.37762 20.7495 9.67983 20.9723 9.90266L24.8837 13.8125H11.125C10.8101 13.8125 10.508 13.9376 10.2853 14.1603C10.0626 14.383 9.9375 14.6851 9.9375 15C9.9375 15.3149 10.0626 15.617 10.2853 15.8397C10.508 16.0624 10.8101 16.1875 11.125 16.1875H24.8837L20.9723 20.0973C20.7495 20.3202 20.6243 20.6224 20.6243 20.9375C20.6243 21.2526 20.7495 21.5548 20.9723 21.7777C21.1952 22.0005 21.4974 22.1257 21.8125 22.1257C22.1276 22.1257 22.4298 22.0005 22.6527 21.7777L28.5902 15.8402C28.7006 15.7299 28.7882 15.5989 28.8479 15.4547C28.9077 15.3106 28.9384 15.1561 28.9384 15C28.9384 14.8439 28.9077 14.6894 28.8479 14.5453C28.7882 14.4011 28.7006 14.2701 28.5902 14.1598Z" fill="#606060" />
                </svg>

                {/* Message */}
                <Typography className="confirm-dialog-message" >
                    {title} < br /> You'll Be Logged Out Automatically in <b>{graceTimeDisplay} </b>
                </Typography>

                {/* Action Buttons */}
                <Box className="confirm-dialog-actions" >
                    <Button variant="outlined"
                        className="confirm-dialog-btn cancel"
                        onClick={() => handleUserAction('logout')}
                    >
                        Logout
                    </Button>

                    <Button
                        variant="contained"
                        className="confirm-dialog-btn save"
                        onClick={() => {
                            // compRefs.current.ts = moment().format('x');
                            compRefs.current.autologoutWorker.terminate();
                            // debugger;
                            sessionStorage.removeItem('documentHiddenTime');
                            clearInterval(compRefs.current.intervalId);
                            compRefs.current.startCounterCalled = 0;
                            compRefs.current.hiddenTime = 0;
                            compRefs.current.visibleTime = 0;
                            graceTimeCounter = graceTime * 60000;
                            setGraceTimeCounter(graceTimeCounter);
                            compRefs.current.graceTimeCounter = graceTimeCounter;
                            handleUserAction('keeploggedin');
                            compRefs.current.autologoutWorker = new Worker('/workers/app.autologout.js')
                        }}> Stay Logged In</Button></Box></DialogContent></Dialog>
    )
}

/**
 * display meta info above grid/chart in single or multiple tiles
 * @returns {JSX.Element}
 */
function DisplayMetaInfo(props) {
    let { className, generationTime, scopeType } = props;
    //Format for time display : Thu, Jan 31 15:04 (GMT +05:30)
    const timeString = "2025-04-01T06:00:14-04:00";
    const offsetStr = generationTime ? generationTime.substr(-6) : '+00:00';
    // generationTime = moment(generationTime).utcOffset(offsetStr).format("ddd, MMM DD HH:mm (\\G\\M\\T Z)");
    // console.log("generationTime", scopeType, moment("2025-05-04T06:00:13-04:00").format("ddd, MMM DD HH:mm (\\G\\M\\T Z)"));
    generationTime = moment(generationTime).format("ddd, MMM DD HH:mm (\\G\\M\\T Z)");

    return (
        <div className={className} >
            <Grid container spacing={0} >
                <Grid>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M6 0.3125C4.87512 0.3125 3.7755 0.646066 2.8402 1.27102C1.90489 1.89597 1.17591 2.78423 0.745438 3.82349C0.314964 4.86274 0.202333 6.00631 0.421786 7.10958C0.64124 8.21284 1.18292 9.22626 1.97833 10.0217C2.77374 10.8171 3.78716 11.3588 4.89043 11.5782C5.99369 11.7977 7.13726 11.685 8.17651 11.2546C9.21577 10.8241 10.104 10.0951 10.729 9.15981C11.3539 8.2245 11.6875 7.12488 11.6875 6C11.6859 4.49207 11.0862 3.04636 10.0199 1.98009C8.95365 0.913821 7.50793 0.314092 6 0.3125ZM6 10.8125C5.04818 10.8125 4.11773 10.5303 3.32632 10.0014C2.53491 9.47264 1.91808 8.72103 1.55383 7.84166C1.18959 6.9623 1.09428 5.99466 1.27997 5.06113C1.46566 4.12759 1.92401 3.27009 2.59705 2.59705C3.27009 1.92401 4.1276 1.46566 5.06113 1.27997C5.99466 1.09428 6.9623 1.18958 7.84167 1.55383C8.72104 1.91808 9.47265 2.53491 10.0014 3.32632C10.5303 4.11773 10.8125 5.04818 10.8125 6C10.8111 7.27591 10.3036 8.49915 9.40136 9.40135C8.49915 10.3036 7.27591 10.8111 6 10.8125ZM6.875 8.625C6.875 8.74103 6.82891 8.85231 6.74686 8.93436C6.66481 9.01641 6.55353 9.0625 6.4375 9.0625C6.20544 9.0625 5.98288 8.97031 5.81878 8.80622C5.65469 8.64212 5.5625 8.41956 5.5625 8.1875V6C5.44647 6 5.33519 5.95391 5.25314 5.87186C5.1711 5.78981 5.125 5.67853 5.125 5.5625C5.125 5.44647 5.1711 5.33519 5.25314 5.25314C5.33519 5.17109 5.44647 5.125 5.5625 5.125C5.79457 5.125 6.01713 5.21719 6.18122 5.38128C6.34531 5.54538 6.4375 5.76794 6.4375 6V8.1875C6.55353 8.1875 6.66481 8.23359 6.74686 8.31564C6.82891 8.39769 6.875 8.50897 6.875 8.625ZM5.125 3.59375C5.125 3.46396 5.16349 3.33708 5.2356 3.22916C5.30771 3.12124 5.4102 3.03712 5.53012 2.98745C5.65003 2.93778 5.78198 2.92479 5.90928 2.95011C6.03658 2.97543 6.15351 3.03793 6.24529 3.12971C6.33707 3.22149 6.39957 3.33842 6.42489 3.46572C6.45021 3.59302 6.43722 3.72497 6.38755 3.84489C6.33788 3.9648 6.25377 4.06729 6.14585 4.1394C6.03793 4.21151 5.91105 4.25 5.78125 4.25C5.6072 4.25 5.44028 4.18086 5.31721 4.05779C5.19414 3.93472 5.125 3.7678 5.125 3.59375Z" fill="#606060" />
                    </svg>
                </Grid>
                <Grid>
                    Rate variance is in comparison to {generationTime}
                </Grid>
            </Grid>
        </div>
    );
}

function DisplayComparisonAsOfDate(props) {
    let { className, lyAsOfDate } = props;
    let generationTime = moment(lyAsOfDate).format("ddd, MMM DD, YYYY");
    return (
        <div className={className} >
            <Grid container spacing={0} >
                <Grid>
                    Comparison As of Date: <span className={'weight-600'}> {generationTime} </span>
                </Grid>
            </Grid>
        </div>
    );
}

/**
 * display formatted values in compset grid cell
 * @returns {JSX.Element}
 */
const CompsetGridCellDataFormatter = (props) => {
    let { value, varianceValue, scopeType, tile } = props;
    // if(tile === 'compset') debugger;
    let className = props.className || 'compset-values';
    className = className + ' ' + scopeType;
    let formattedDisplayItem = value;

    if (tile !== 'compset') {
        return <>{value} </>;
    }
    if (!varianceValue && !value && scopeType !== 'Dba') {
        return <></>;
        //formattedDisplayItem = <div className={className}><div className="compset-value main-val"> &nbsp; </div><div className="compset-value variance-na"> &nbsp; </div></div>
    }
    //Added to fix decimal values in table average row
    if (props.className === 'compset-average-values') {
        varianceValue = Math.round(varianceValue);
    }
    if (varianceValue) {
        if (value) {
            if (varianceValue < 0) {
                formattedDisplayItem = <div className={className}> <div className="compset-value main-val" > {value} </div><div className="compset-value variance-red" dangerouslySetInnerHTML={{ __html: varianceValue }}></div > </div>
            } else if (varianceValue > 0) {
                formattedDisplayItem = <div className={className}> <div className="compset-value main-val" > {value} </div><div className="compset-value variance-green" dangerouslySetInnerHTML={{ __html: '+' + varianceValue }}></div > </div>
            } else {
                formattedDisplayItem = <div className={className}> <div className="compset-value main-val" > {value} </div><div className="compset-value variance-green" dangerouslySetInnerHTML={{ __html: '&nbsp;' }}></div > </div>
            }
        } else {
            if (varianceValue < 0) {
                formattedDisplayItem = <div className={className}> <div className="compset-value main-val"> &nbsp; </div><div className="compset-value variance-red" dangerouslySetInnerHTML={{ __html: varianceValue }}></div > </div>
            } else if (varianceValue > 0) {
                formattedDisplayItem = <div className={className}> <div className="compset-value main-val"> &nbsp; </div><div className="compset-value variance-green" dangerouslySetInnerHTML={{ __html: '+' + varianceValue }}></div > </div>
            } else {
                formattedDisplayItem = <div className={className}> <div className="compset-value main-val"> &nbsp; </div><div className="compset-value variance-green" dangerouslySetInnerHTML={{ __html: '&nbsp;' }}></div > </div>
            }
        }
    } else {
        if (value && scopeType !== 'Dba') {
            formattedDisplayItem = <div className={className}> <div className="compset-value main-val" > {value} </div><div className="compset-value variance-na"> &nbsp; </div > </div>
        } else {
            formattedDisplayItem = <div className={className}> <div className="compset-value main-val" > {value} </div><div className="compset-value variance-na"> &nbsp; </div > </div>
        }
    }
    return (formattedDisplayItem);
}

/**
 * display meta info above grid/chart in single or multiple tiles
 * @returns {JSX.Element}
                                                    */
function DisplayMetaInfoPricing(props) {
    let { className } = props;

    return (
        <div className={className} >
            <Grid container spacing={0} >
                <Grid spacing={1}>
                    <span className='color-block auto-rate-push' > </span>
                    Auto Rate Push
                </Grid>
                <Grid>
                    <span className='color-block rate-overridden'></span>
                    User Override
                </Grid>
            </Grid>
        </div>
    );
}

export {
    TableLottieLoader,
    LightTooltip, DashboardLogo, DashboardLogoSmall,
    DashboardFooter, ResponsiveTilesMenu, CustomSVGIcon,
    FBNotifications, ConfirmDialog, ConfirmLogoutDialog
    , DisplayMetaInfo, CompsetGridCellDataFormatter,
    DisplayMetaInfoPricing, DisplayComparisonAsOfDate
};